export default __webpack_public_path__ + "static/media/mystery-match.a3935ec2.jpeg";